module.exports = __webpack_public_path__ + "static/media/YM82_4.c413d22f.jpg";